import { Component } from 'preact'
import Tooltip from '../ui-components/Tooltip'
import StatusCircle from '../ui-components/StatusCircle'

class Title extends Component {
  constructor (props) {
    super(props)
    this.state = {
      titleInputVisible: false
    }
    this.onTitleClicked = this.onTitleClicked.bind(this)
    this.onClickOutsideOfTitle = this.onClickOutsideOfTitle.bind(this)
    this.onPressEnterInTitle = this.onPressEnterInTitle.bind(this)
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.onClickOutsideOfTitle)
    document.addEventListener('keypress', this.onPressEnterInTitle)
  }

  onTitleClicked () {
    this.setState({ titleInputVisible: true }, () => {
      this.titleInputRef.focus()
    })
  }

  onClickOutsideOfTitle (e) {
    if (this.titleInputRef && !this.titleInputRef.contains(e.target)) {
      this.titleInputRef.blur()
      this.setState({ titleInputVisible: false })
    }
  }

  onPressEnterInTitle (e) {
    if (this.titleInputRef && e.keyCode === 13) {
      this.titleInputRef.blur()
      this.setState({ titleInputVisible: false })
    }
  }

  render (props, state) {
    const { title, onTitleChanged, error, meta, draftSaved } = props

    let metadata = 'New article'
    if (draftSaved) {
      const status = meta.is_scheduled ? 'Scheduled' : 'Draft'
      const lastEdited = meta.last_edited_at ? `Last edited ${meta.last_edited_at} by ${meta.last_edited_by}` : `Created ${meta.created_at} by ${meta.created_by}`
      metadata = `${status} · ${lastEdited}`
    }

    return (
      <div>
        {this.state.titleInputVisible
          ? <input
            class='article-creator__title qa-title-input form-control'
            type='text'
            value={title}
            required
            onChange={(e) => onTitleChanged(e.target.value.trim())}
            maxLength={250}
            ref={(titleInput) => { this.titleInputRef = titleInput }}
          />
          : <div>
            <Tooltip
              trigger={
                <h2
                  class={`article-creator__title qa-title-text ${title ? '' : 'article-creator__title--empty'}`}
                  onClick={this.onTitleClicked}>{title || 'Untitled'}
                </h2>}
              tooltipMessage={error ? error : title ? 'Rename' : 'Add a title'} //eslint-disable-line
              customClasses={error ? 'tooltip-show' : null}
              qaClasses='qa-title-tooltip'
            />
            <div class='article-creator__creation-status pull-left'>
              <StatusCircle variant={draftSaved && (meta.is_scheduled ? 'scheduled' : 'draft')} />
              <p class='article-creator__creation-status-text'>
                { metadata }
              </p>
            </div>
          </div>
        }
      </div>
    )
  }
}

export default Title
